import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { navigation } from "../data/navigation";

export default function FooterOne() {
  const committees = navigation
    .find((item) => item.title === "Academics")
    .submenu.find((item) => item.title === "Committee cell").submenu;
  return (
    <footer className="univ-footer">
      <div className="univ-wrap">
        <div className="univ-footer-top">
          <div className="univ-footer-brand">
            <Link to="/">
              <img
                src="/assets/images/logo/logo-full.png"
                alt="Takshashila Medical College & Hospital"
                loading="lazy"
              />
            </Link>
            <p>
              Shaping Healthcare.
              <br />
              Empowering Healers.
              <br />
              <em>Serving Humanity.</em>
            </p>
            <a
              href="https://takshashilauniv.ac.in"
              target="_blank"
              rel="noreferrer"
            >
              Takshashila University <ArrowUpRight size={15} />
            </a>
          </div>
          <div>
            <h2>Explore</h2>
            <Link to="/about-us">About the college</Link>
            <Link to="/courses-mbbs">MBBS programme</Link>
            <Link to="/hospital">Teaching hospital</Link>
            <Link to="/dean">Dean & MS</Link>
            <Link to="/faculty">Faculty</Link>
            <Link to="/gallery">Gallery</Link>
            <Link to="/infrastructure">Infrastructure</Link>
            <Link to="/fee/hostel-fee">Hostel fees</Link>
          </div>
          <div>
            <h2>Committees & support</h2>
            {committees.map((item) => (
              <Link to={item.link} key={item.link}>
                {item.title}
              </Link>
            ))}
          </div>
          <div className="univ-footer-contact">
            <h2>Find us</h2>
            <p>
              Ongur, Tindivanam Taluk,
              <br />
              Villupuram District,
              <br />
              Tamil Nadu – 604 305, India
            </p>
            <a href="tel:+918925969546">+91 8925969546</a>
            <a href="mailto:deantmch@takshashilauniv.ac.in">
              deantmch@takshashilauniv.ac.in
            </a>
            <Link to="/contact-us" className="univ-footer-contact-link">
              Contact the college <ArrowUpRight size={15} />
            </Link>
            <div className="univ-socials">
              <a
                href="https://www.facebook.com/people/Takshashila-University/100083042965090"
                target="_blank"
                rel="noreferrer"
              >
                Facebook
              </a>
              <a
                href="https://www.instagram.com/takshashilauniv/"
                target="_blank"
                rel="noreferrer"
              >
                Instagram
              </a>
              <a
                href="https://www.youtube.com/@takshashilauniversityofficial"
                target="_blank"
                rel="noreferrer"
              >
                YouTube
              </a>
            </div>
          </div>
        </div>
        <div className="univ-footer-bottom">
          <span>
            © {new Date().getFullYear()} Takshashila University. All rights
            reserved.
          </span>
          <div>
            <Link to="/pro-fomra">MARB NMC Pro-Forma</Link>
            <Link to="/mci-detail">MSR Clause B.1.11</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
